import type { ComponentWithClassName } from '@listening/utils/react-helpers';
import { Button } from '@listening/frontend/components/radix/button';
import { ScrollArea } from '@listening/frontend/components/radix/scroll-area';
import { useRouter } from '@tanstack/react-router';
import { NavArrowLeft } from 'iconoir-react';

export function DashboardPage({
  children,
  header,
}: {
  children?: React.ReactNode;
  header?: {
    Icon: ComponentWithClassName;
    title: string;
    rightSideSlot?: React.ReactNode;
  };
}) {
  const { history } = useRouter();

  return (
    <article className='relative flex h-full flex-col overflow-hidden'>
      <ScrollArea
        className='grow'
        viewPortClassName='bg-transparent'
        useFlexFix
      >
        <div className='mx-auto flex w-full max-w-[var(--v2-content-max)] flex-col gap-[var(--v2-gap-6)] px-[var(--v2-content-pad)] py-[var(--v2-gap-6)] pb-16'>
          {header && (
            <div className='flex w-full items-center justify-between'>
              <Button
                onClick={() => {
                  history.go(-1);
                }}
                variant='ghost'
                className='h-auto rounded-full p-1 text-[var(--v2-text-primary)]'
              >
                <NavArrowLeft className='size-6' />
              </Button>
              <div className='flex items-center gap-2'>
                <header.Icon className='size-5 text-[var(--v2-text-primary)]' />
                <h1
                  className='text-base text-[var(--v2-text-primary)]'
                  style={{ fontWeight: 'var(--v2-heading-weight)' }}
                >
                  {header.title}
                </h1>
              </div>
              {header.rightSideSlot ?? <div />}
            </div>
          )}
          {children}
        </div>
      </ScrollArea>
    </article>
  );
}
